<template>
  <b-row>
    <b-col sm="12">
      <b-form-group label="Seleccione pallet de origen">
        <v-select
          v-model="selectPalletOut"
          :options="optionPalletsOut"
          :clearable="false"
          @search="onSearchOut"
          :filterable="false"
          placeholder="Buscar Pallet"
          @keypress.native="clearSelectedOut"
          @search:focus="clearSelectedOut"
        >
          <template slot="no-options"> escribe para buscar pallets </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.number }} - {{ option.container }}
            </div>
          </template>

          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.number }} - {{ option.container }}
            </div>
          </template>
        </v-select>
      </b-form-group>

      <b-table
        striped
        hover
        small
        :fields="columns"
        :items="tableDataPalletOut"
      >
        <template v-slot:cell(Agregar)="data">
          <a
            v-show="showBtnAdd"
            target="_blank"
            href="#"
            title="Agregar"
            @click.prevent="AddPalletIn(data.item)"
            class="fa fa-lg fa-plus text-primary text-center"
          ></a>
        </template>

        <template v-slot:cell(Variedad)="data">
          {{ data.item.Variedad }} - {{ data.item.condicion }}
        </template>

        <template v-slot:cell(+)="data">
          <p class="text-info" @click="data.toggleDetails">+</p>
        </template>

        <template v-slot:cell(fecha)="data">
          {{ data.item.fecha | moment }}
        </template>

        <template v-slot:cell(Cantidad_salir)="data">
          <b-form-input
            id="input-small"
            size="sm"
            v-on:keyup="inputSoloNumero"
            v-model="data.item.Cantidad_salir"
            placeholder="Cajas a mover"
          >
          </b-form-input>
        </template>

        <template v-slot:row-details="row">
          <b-card class="">
            <b-row class="mb-0">
              <b-col sm="3" class="text-sm-right"><b>Producto:</b></b-col>
              <b-col>{{ row.item.Producto }}</b-col>
            </b-row>
            <b-row class="mb-0">
              <b-col sm="3" class="text-sm-right"
                ><b>Tipo de Producto:</b></b-col
              >
              <b-col>{{ row.item.Tipo_producto }}</b-col>
            </b-row>
            <b-row class="mb-0">
              <b-col sm="3" class="text-sm-right"><b>KN:</b></b-col>
              <b-col>{{ row.item.kilos_netos }}</b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>
    </b-col>

    <b-col sm="12">
      <div align="center">
        <b-button @click="movimientosRepaletizaje" variant="primary"
          >Movimientos</b-button
        >&nbsp;
        <b-button @click="newPalletModal" variant="primary"
          >Nuevo Pallet</b-button
        >&nbsp;
        <!--        <b-button @click="reiniciarRepaletizaje" variant="primary">Reiniciar</b-button>-->
      </div>
      <br />
    </b-col>

    <b-col sm="12">
      <b-form-group label="Seleccione pallet de destino">
        <v-select
          :options="optionpalletsIn"
          v-model="selectPalletIn"
          :clearable="false"
          @search="onSearchIn"
          :filterable="false"
          placeholder="Buscar Pallet"
          @keypress.native="clearSelectedIn"
          @search:focus="clearSelectedIn"
        >
          <template slot="no-options"> escribe para buscar pallets </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.number }} - {{ option.container }}
            </div>
          </template>

          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.number }} - {{ option.container }}
            </div>
          </template>
        </v-select>
      </b-form-group>

      <b-table
        striped
        hover
        small
        :fields="columns2"
        :items="tableDataPalletIn"
      >
        <template v-slot:cell(Variedad)="data">
          {{ data.item.Variedad }} - {{ data.item.condicion }}
        </template>

        <template v-slot:cell(fecha)="data">
          {{ data.item.fecha | moment }}
        </template>
      </b-table>
    </b-col>

    <!-- Modal Component Nuevo Pallet-->
    <b-modal
      title="Nuevo pallet"
      size="sm"
      class="modal-primary"
      v-model="modalShown"
      hide-footer
    >
      <form @submit.prevent="onSubmitNuevoPallet">
        <div>
          <b-row>
            <b-col>
              <b-form-group label="Tipo de embarque">
                <b-form-select
                  id="client"
                  v-model="shipment_type"
                  :options="shipment_types"
                >
                </b-form-select>
              </b-form-group>
              <b-form-group label="Destino (Opcional)">
                <b-form-select
                  id="destination"
                  text-field="name"
                  value-field="id"
                  v-model="destination"
                  :options="destinations"
                >
                </b-form-select>
              </b-form-group>
              <b-form-group
                label="Número de Pallet (Opcional)"
                description="Ingrese numero de pallet. Deje en blanco si desea un numero automático."
              >
                <b-form-input
                  type="text"
                  placeholder="123456789"
                  v-model="pallet_number"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="align-right">
              <b-button
                :disabled="loading"
                type="submit"
                variant="primary"
                class="pull-right"
              >
                <b-spinner small v-if="loading"></b-spinner>
                <span v-if="!loading">Crear</span>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </form>
    </b-modal>

    <!-- Modal Component Muestra y elimina movimeintos  proceso-->
    <b-modal
      id="modalMovimientosPallet"
      title="Movimientos Proceso"
      size="md"
      class="modal-primary"
      v-model="modalShownMovimiento"
      hide-footer
    >
      <b-table-lite
        hover
        :fields="columns3"
        :items="tableDataMovimientos"
        small
        caption-top
        responsive
      >
        <template v-slot:cell(Cantidad)="data">
          <a href="#" title="Ver" @click.prevent="data.toggleDetails">{{
            data.item.Cantidad
          }}</a>
        </template>

        <template v-slot:cell(Acciones)="data">
          <a
            target="_blank"
            href="#"
            @click.prevent="revertRow(data.item)"
            class="fa fa-lg fa-reply text-danger"
            title="Revertir Movimiento"
          ></a
          >&nbsp;
        </template>

        <template v-slot:row-details="row">
          <b-card class="">
            <b-row class="mb-0">
              <b-col class="text-sm-right font-weight-bold">Formato:</b-col>
              <b-col>{{ row.item.container }}</b-col>
            </b-row>
            <b-row class="mb-0">
              <b-col class="text-sm-right font-weight-bold">Variedad:</b-col>
              <b-col>{{ row.item.variety }}</b-col>
            </b-row>
            <b-row class="mb-0">
              <b-col class="text-sm-right font-weight-bold">Huerto:</b-col>
              <b-col>{{ row.item.origin }}</b-col>
            </b-row>
            <b-row class="mb-0">
              <b-col class="text-sm-right font-weight-bold"
                >Fecha embajale:</b-col
              >
              <b-col>{{ row.item.creation_date | moment }}</b-col>
            </b-row>
            <b-row v-if="row.item.plant" class="mb-0">
              <b-col class="text-sm-right font-weight-bold">Planta:</b-col>
              <b-col>{{ row.item.plant.name }}</b-col>
            </b-row>
          </b-card>
        </template>
      </b-table-lite>
    </b-modal>
  </b-row>
</template>

<script>
import {
  required,
  numeric,
  minLength,
  between
} from "vuelidate/lib/validators";
import { ClientTable, Event } from "vue-tables-2";
import Vue from "vue";
import miniToastr from "mini-toastr"; // https://github.com/se-panfilov/mini-toastr
import { ModelSelect } from "vue-search-select";
import { bus } from "../../main";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

import VueNotifications from "vue-notifications";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

Vue.use(miniToastr);
Vue.use(ClientTable);

export default {
  name: "RepaletizajeForm2",
  components: {
    vSelect
  },
  props: ["processData"],
  data() {
    return {
      loading: false,
      showBtnAdd: true,
      pallet_number: null,
      destination: null,
      shipment_type: null,
      shipment_types: [
        { value: null, text: "--------" },
        { value: 1, text: "Marítimo" },
        { value: 2, text: "Aéreo" }
      ],
      optionPalletsOut: [],
      optionpalletsIn: [],
      selectPalletOut: "",
      selectPalletIn: "",
      input_cantidad_nueva: [],

      tableDataPalletOut: [],
      tableDataPalletIn: [],
      modalShown: false,
      modalShownMovimiento: false,
      tableDataMovimientos: [],
      theme: "bootstrap4",
      template: "default",
      columns: [
        // "Producto",
        // "Tipo_producto",
        "+",
        "Variedad",
        "Origen",
        {
          key: "planta",
          label: "Planta",
          formatter: (value, key, item) => {
            return value ? value.name : "-";
          },
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true
        },
        "planta",
        "fecha",

        // "kilos_netos",
        "formato",
        "Especificaciones",
        "Cantidad",
        "Cantidad_salir",
        "Agregar"
      ],
      columns2: [
        // "Producto",
        // "Tipo_producto",
        "Variedad",
        "Origen",
        {
          key: "planta",
          label: "Planta",
          formatter: (value, key, item) => {
            return value ? value.name : "-";
          }
        },
        "fecha",
        // "kilos_netos",
        "formato",
        "Especificaciones",
        "Cantidad"
      ],
      columns3: [
        {
          key: "Pallet_salida",
          label: "Pallet Origen"
        },
        "Cantidad",
        {
          key: "Pallet_entrada",
          label: "Pallet Destino"
        },
        // "Producto",
        // "Tipo_producto",
        // "Variedad",
        // "Origen",
        //
        "Acciones"
      ],
      options: {
        // see the options API
        texts: {
          filter: "Filtrar:",
          filterBy: "Buscar",
          count: " "
        },
        columnsDropdown: false,
        filterByColumn: false,
        filterable: false,
        texts: {
          filter: "Filtrar",
          filterBy: "Buscar",
          filterPlaceholder: "",
          count: "",
          limit: ""
        },
        perPage: 5
      }
    };
  },
  filters: {
    moment(value) {
      return moment(value).format("DD-MM-YYYY");
    }
  },
  computed: {
    autoNumber() {
      return this.pallet_number === "" || this.pallet_number === null;
    }
  },
  watch: {
    selectPalletOut: function (val) {
      if (this.selectPalletOut != "" && val != null) {
        this.tableDataPalletOut = [];

        this.$axios
          .get("/api/v1/allstock/" + val.id + "/get_content_pallet/")
          .then((res) => {
            const datos = res.data.data;

            for (let key in datos) {
              var rowNew = {
                Producto: datos[key].variety.product.name,
                Tipo_producto: datos[key].product_type.name,
                Variedad: datos[key].variety.name,
                Origen: datos[key].origin.name,
                kilos_brutos: datos[key].gross_kilograms,
                kilos_netos: datos[key].net_kilograms,
                Cantidad: datos[key].quantity,
                Especificaciones: datos[key].specifications,
                IDContenido: datos[key].id,
                formato: datos[key].container.name,
                condicion: datos[key].condition,
                fecha: datos[key].creation_date,
                planta: datos[key].plant,
                Cantidad_salir: null
              };

              this.tableDataPalletOut.push(rowNew);
            }
          })
          .catch((error) => console.log(error.message));
      }
    },

    selectPalletIn: function (val) {
      if (this.selectPalletOut != "" && val != null) {
        this.tableDataPalletIn = [];

        this.$axios
          .get("/api/v1/allstock/" + val.id + "/get_content_pallet/")
          .then((res) => {
            const datos = res.data.data;

            for (let key in datos) {
              var rowNew = {
                Producto: datos[key].variety.product.name,
                Tipo_producto: datos[key].product_type.name,
                Variedad: datos[key].variety.name,
                Origen: datos[key].origin.name,
                kilos_brutos: datos[key].gross_kilograms,
                kilos_netos: datos[key].net_kilograms,
                Cantidad: datos[key].quantity,
                Especificaciones: datos[key].specifications,
                fecha: datos[key].creation_date,
                condicion: datos[key].condition,
                planta: datos[key].plant,
                IDContenido: datos[key].id
              };

              this.tableDataPalletIn.push(rowNew);
            }
          })
          .catch((error) => console.log(error.message));
      }
    }
  },

  mounted() {
    this.$axios
      .get("/api/comex/destination_market/?no_page")
      .then((res) => {
        this.destinations = res.data;
      })
      .catch((error) => {
        console.log(error.response);
      });
  },

  created() {},
  methods: {
    revertRow(row) {
      const data = {
        movimiento_id: row.movimiento_id
      };

      this.$axios
        .put("/api/v1/pallet/reverse_movements/", data)
        .then((res) => {
          miniToastr.info("Movimiento revertido con éxito", "");
          this.clearSelectedOut();
          this.clearSelectedIn();
          this.modalShownMovimiento = false;
        })
        .catch(function (error) {
          miniToastr.error("Problemas al crear el pallet");
        });
    },
    async onSubmitNuevoPallet() {
      const thisV = this;
      thisV.loading = true;
      const data = {
        auto_number: thisV.autoNumber,
        destination: thisV.destination,
        number: thisV.pallet_number,
        shipment_type: thisV.shipment_type
      };
      try {
        const res = await thisV.$axios.post(
          "/api/v1/pallet/new_pallet_repaletizaje/",
          data
        );
        if (res.data.status == 1) {
          const newPallet = {
            id: res.data.id,
            number: res.data.number,
            container: "Nuevo pallet"
          };

          thisV.modalShown = false;
          thisV.shipment_type = null;
          thisV.pallet_number = null;
          thisV.selectPalletIn = newPallet;

          thisV.$swal.fire(
            "Pallet numero (" + res.data.number + ") creado con exito",
            "",
            "success"
          );
        }

        if (res.data.status == 2) {
          miniToastr.error("Numero de pallet ingresado ya éxiste", "");
        }
        thisV.loading = false;
      } catch (error) {
        thisV.loading = false;
        console.log("%o", error);
        miniToastr.error("Problemas al crear el pallet");
      }
    },
    onSearchOut(search, loading) {
      loading(true);
      this.searchOut(loading, search, this);
    },
    searchOut: _.debounce((loading, search, vm) => {
      vm.$axios
        .get("/api/v1/pallet/get_pallets_repaletizaje_out/", {
          params: {
            q: escape(search),
            client_customer: vm.processData.client_customer.id
          }
        })
        .then((res) => {
          loading(false);
          vm.optionPalletsOut = res.data.data;
        })
        .catch((error) => {
          console.log(error.response);
        });
    }, 350),
    clearSelectedOut() {
      this.selectPalletOut = "";
      this.optionPalletsOut = [];
      this.tableDataPalletOut = [];
    },
    onSearchIn(search, loading) {
      loading(true);
      this.searchIn(loading, search, this);
    },
    searchIn: _.debounce((loading, search, vm) => {
      vm.$axios
        .get("/api/v1/pallet/get_pallets_repaletizaje_in/", {
          params: {
            q: escape(search),
            client_customer: vm.processData.client_customer.id
          }
        })
        .then((res) => {
          loading(false);
          vm.optionpalletsIn = res.data.data;
        })
        .catch((error) => {
          console.log(error.response);
        });
    }, 350),
    clearSelectedIn() {
      this.selectPalletIn = "";
      this.optionpalletsIn = [];
      this.tableDataPalletIn = [];
    },
    AddPalletIn(row) {
      if (
        row.Cantidad_salir != null &&
        parseFloat(row.Cantidad_salir) <= parseFloat(row.Cantidad)
      ) {
        if (this.selectPalletIn.id != this.selectPalletOut.id) {
          if (this.selectPalletIn != "") {
            const Data = {
              id_pallet_out: this.selectPalletOut.id,
              id_pallet_in: this.selectPalletIn.id,
              content_id: row.IDContenido,
              process_id: this.processData.id,
              quantity_out: row.Cantidad_salir
            };
            this.showBtnAdd = false;
            this.$axios
              .put("/api/v1/pallet/repaletizaje_pallets/", Data)
              .then((res) => {
                this.actualizarPalletContentidoOut(this.selectPalletOut.id);
                this.actualizarPalletContentidoIn(this.selectPalletIn.id);
                this.showBtnAdd = true;
              })
              .catch(function (error) {
                this.showBtnAdd = true;
                miniToastr.error(
                  error.response,
                  "Problemas al realizar la operacion"
                );
              });
          } else {
            this.$swal.fire(
              "Debe seleccionar el pallet destino donde ingresará el contenido",
              "",
              "warning"
            );
          }
        } else {
          this.$swal.fire(
            "Pallet origen y pallet destino deben ser diferentes",
            "",
            "warning"
          );
        }
      } else {
        this.$swal.fire(
          "Cantidad esta en blanco, o supera la cantidad del contenido disponible para mover.",
          "",
          "warning"
        );
      }
    },

    updatePalletNumber(pallet_number) {
      this.optionpalletsIn.find(
        (x) => x.text === pallet_number
      ).text = pallet_number;
      this.optionPalletsOut.find(
        (x) => x.text === pallet_number
      ).text = pallet_number;
    },

    actualizarPalletContentidoOut(val) {
      if (val != null) {
        this.tableDataPalletOut = [];

        this.$axios
          .get("/api/v1/allstock/" + val + "/get_content_pallet/")
          .then((res) => {
            const datos = res.data.data;

            for (let key in datos) {
              var rowNew = {
                Producto: datos[key].variety.product.name,
                Tipo_producto: datos[key].product_type.name,
                Variedad: datos[key].variety.name,
                Origen: datos[key].origin.name,
                kilos_brutos: datos[key].gross_kilograms,
                kilos_netos: datos[key].net_kilograms,
                Cantidad: datos[key].quantity,
                Especificaciones: datos[key].specifications,
                IDContenido: datos[key].id,
                formato: datos[key].container.name,
                condicion: datos[key].condition,
                fecha: datos[key].creation_date,
                planta: datos[key].plant,
                Cantidad_salir: null
              };

              this.tableDataPalletOut.push(rowNew);
            }
          })
          .catch((error) => console.log(error.message));
      }
    },
    actualizarPalletContentidoIn(val) {
      if (val != null) {
        this.tableDataPalletIn = [];

        this.$axios
          .get("/api/v1/allstock/" + val + "/get_content_pallet/")
          .then((res) => {
            const datos = res.data.data;

            for (let key in datos) {
              var rowNew = {
                Producto: datos[key].variety.product.name,
                Tipo_producto: datos[key].product_type.name,
                Variedad: datos[key].variety.name,
                Origen: datos[key].origin.name,
                kilos_brutos: datos[key].gross_kilograms,
                kilos_netos: datos[key].net_kilograms,
                Cantidad: datos[key].quantity,
                Especificaciones: datos[key].specifications,
                fecha: datos[key].creation_date,
                condicion: datos[key].condition,
                formato: datos[key].container.name,
                planta: datos[key].plant,
                IDContenido: datos[key].id
              };

              this.tableDataPalletIn.push(rowNew);
              // this.updatePalletNumber(datos[0].pallet_number);
            }
          })
          .catch((error) => console.log(error.message));
      }
    },
    newPalletModal() {
      this.modalShown = true;
    },
    /*   reiniciarRepaletizaje() {

        this.$axios.get('/api/v1/process/' + this.processData.id + '/restart_repaletizaje/')
          .then(res => {

            this.selectPalletOut = "-";
            this.selectPalletIn = "-";
            this.tableDataPalletOut = [];
            this.tableDataPalletIn = [];

            this.$swal.fire("Proceso reiniciado con exito", "", "success");

          })
          .catch(error => console.log(error.message));


      }, */
    movimientosRepaletizaje() {
      this.modalShownMovimiento = true;

      this.tableDataMovimientos = [];

      this.$axios
        .get(
          "/api/v1/process/" +
            this.processData.id +
            "/process_detail_repaletizaje/"
        )
        .then((res) => {
          const datos = res.data.movement_content;

          for (let key in datos) {
            var rowNew = {
              movimiento_id: datos[key].id,
              Pallet_entrada: datos[key].content.pallet_number,
              Pallet_salida: datos[key].content_reference.pallet_number,
              Producto: datos[key].content.product_name,
              Tipo_producto: datos[key].content.product_type_name,
              Variedad: datos[key].content.variety_name,
              origin: datos[key].content_reference.origin_name,
              kilos_brutos: datos[key].content.gross_kilograms,
              kilos_netos: datos[key].content.net_kilograms,
              Cantidad: datos[key].content.quantity,
              IDContenido: datos[key].content.id,
              container: datos[key].content_reference.container.name,
              condition: datos[key].content_reference.condition,
              variety: datos[key].content_reference.variety_name,
              creation_date: datos[key].content_reference.creation_date,
              plant: datos[key].content_reference.plant
            };

            this.tableDataMovimientos.push(rowNew);
          }
        })
        .catch((error) => console.log(error.message));
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    }
  }
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  /*display: inline-block;*/
  /*width: 100%;*/
  min-height: calc(1.5em + 0.75rem + 2px);
  /*padding: 0.375rem 1.75rem 0.375rem 0.75rem;*/
  font-size: 0.6875rem;
  font-weight: 400;
  /*line-height: 1.5;*/
  color: #5c6873;
  /*vertical-align: middle;*/
  /*background-color: #fff;*/
  border: 1px solid #e4e7ea;
  /*border-radius: 0.25rem;*/
  /*-webkit-appearance: none;*/
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}

img {
  height: auto;
  max-width: 2.5rem;
  margin-right: 1rem;
}

.d-center {
  display: flex;
  align-items: center;
}

.selected img {
  width: auto;
  max-height: 23px;
  margin-right: 0.5rem;
}

.v-select .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
  border-bottom: none;
}

.v-select .dropdown li a {
  padding: 10px 20px;
  width: 100%;
  font-size: 1.25em;
  color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
  color: #fff;
}
</style>
